import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Hidden } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';

import LocationIcon from 'public/icons/profile/location.svg';
import TeamIcon from 'public/icons/profile/team.svg';
import GraduationHatIcon from 'public/icons/profile/graduation-hat.svg';
import ProfileRating from './ProfileRating';
import Bio from 'components/Bio';
import styles from 'styles/components/profile/Profile.module.scss';

const Info = ({ profile, setProfile, isDialog, profilePreview }) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isLongerText = text => {
    if (text.length > 37) {
      return `${text.slice(0, 40)}...`;
    } else {
      return text;
    }
  };

  return (
    <div className={clsx(styles.name, { [styles.desktopPadding]: !isDialog && !mobile })}>
      <h3>{profile.display_name}</h3>

      <div className={styles.info}>
        <ProfileRating rating={profile.success_score} />

        {profile.athlete && (
          <div className={styles.location}>
            {profile.athlete_level === 'professional_athlete' ? (
              <TeamIcon width={12} height={12} style={{ fill: '#323643', opacity: 0.5 }} />
            ) : (
              <GraduationHatIcon width={12} height={12} style={{ fill: '#323643', opacity: 0.5 }} />
            )}

            <h6>
              {profile.athlete_level === 'professional_athlete'
                ? isLongerText(profile.team_name)
                : isLongerText(profile.school?.name || profile.school_name)}
            </h6>
          </div>
        )}

        {profile.location && !profile.athlete && (
          <div className={styles.location}>
            <LocationIcon width={12} height={12} />
            <h6>{isLongerText(profile.location)}</h6>
          </div>
        )}

        {profile.bio && !isDialog && (
          <Hidden smDown>
            <Bio profile={profile} setProfile={setProfile} profilePreview={profilePreview} />
          </Hidden>
        )}
      </div>
    </div>
  );
};

export default Info;
